<template>
  <div>
    <a-switch-field
      varName="registration_options.enabled"
      varLabel="Registration Enabled"
      :varRequired="true"
      :varInitial="data.registration_options.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
    />
    <a-switch-field
      varName="registration_options.verification_methods.email"
      varLabel="Verify Email"
      :varRequired="true"
      :varInitial="data.registration_options.verification_methods.email"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
    />
    <a-switch-field
      varName="registration_options.verification_methods.sms"
      varLabel="Verify Phone Number"
      :varRequired="true"
      :varInitial="data.registration_options.verification_methods.sms"
      :formLayout="formLayout"
      :size="size"
      :disabled="true"
    />
    <a-switch-field
      varName="registration_options.verification_required"
      varLabel="Verification Required"
      :varRequired="true"
      :varInitial="data.registration_options.verification_required"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      description="To login user requires email or phone number verified."
    />
    <a-url-field
      varName="registration_options.redirect_url"
      varLabel="Redirect URL"
      :varRequired="false"
      :varInitial="data.registration_options.redirect_url"
      :formLayout="formLayout"
      :size="size"
      icon="link"
      description="Please provide the URL where the user will be redirected after registration."
    />
    <a-url-field
      varName="registration_options.terms_conditions_url"
      varLabel="Terms & Conditions URL"
      :varRequired="false"
      :varInitial="data.registration_options.terms_conditions_url"
      :formLayout="formLayout"
      :size="size"
      icon="link"
      description="URL where the user can review the terms & conditions applicable to your service."
    />
    <a-url-field
      varName="registration_options.privacy_policy_url"
      varLabel="Privacy Policy URL"
      :varRequired="false"
      :varInitial="data.registration_options.privacy_policy_url"
      :formLayout="formLayout"
      :size="size"
      icon="link"
      description="URL where the user can review the privacy policy applicable to your service."
    />
    <a-registration-field :formLayout="formLayout" :size="size" :data="data" varName="terms_conditions" varVerbose="Terms of Service" />
    <a-registration-field :formLayout="formLayout" :size="size" :data="data" varName="given_name" varVerbose="Given Name" />
    <a-registration-field :formLayout="formLayout" :size="size" :data="data" varName="family_name" varVerbose="Family Name" />
    <a-registration-field :formLayout="formLayout" :size="size" :data="data" varName="middle_name" varVerbose="Middle Name" />
    <a-registration-field :formLayout="formLayout" :size="size" :data="data" varName="phone" varVerbose="Phone" />
    <a-registration-field :formLayout="formLayout" :size="size" :data="data" varName="preferred_username" varVerbose="Preferred Username" />
  </div>
</template>

<script>
import ARegistrationField from "@/components/Form/ARegistrationField";

export default {
  components: {
      ARegistrationField
  },
  props: {
    formLayout: String,
    size: String,
    data: Object
  }
};
</script>